import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "progressbar",
  class: "ProgressBar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "ProgressBar-bar ProgressBar-bar--primary" }, [
      _createElementVNode("span", { class: "ProgressBar-inner" })
    ], -1),
    _createElementVNode("div", { class: "ProgressBar-bar ProgressBar-bar--secondary" }, [
      _createElementVNode("span", { class: "ProgressBar-inner" })
    ], -1)
  ])))
}